import * as React from 'react';

import { IFullscreenAppProps } from './types';

import * as s from './FullscreenApp.scss';

export const FullscreenApp = ({
	url,
	appId,
}: IFullscreenAppProps) =>
	<div className={s.app}>
		<iframe
			id={appId}
			referrerPolicy="no-referrer-when-downgrade"
			src={url}
			width="100%"
			height="100%"
			allowFullScreen
			allow="microphone; camera"
			frameBorder="0"
		/>
	</div>;
